import React from 'react'

import type { TimelineEvent } from '@fourthwall/components'
import { Subsection, Timeline } from '@fourthwall/components'

type GiftCardTimelineProps = {
  timelineEvents?: TimelineEvent[]
}

export const GiftCardTimeline = ({ timelineEvents }: GiftCardTimelineProps) => {
  return (
    <Subsection title="Timeline">
      {timelineEvents && <Timeline size="large" events={timelineEvents} />}
    </Subsection>
  )
}
